// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__AWTzs","verticalDivider":"Divider_verticalDivider__ZTYP5"};